import React from 'react';

const MOBILE_BREAKPOINT = 641; // Using the same breakpoint as the original component

/**
 * Custom hook to detect if the current viewport is mobile.
 * Uses matchMedia for better performance and accuracy.
 * @returns {boolean} True if the viewport width is mobile size.
 */
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const onChange = (e) => {
      setIsMobile(e.matches);
    };

    // Use addListener for broader browser support
    if (mql.addListener) {
      mql.addListener(onChange);
    } else {
      mql.addEventListener('change', onChange);
    }

    // Set initial state using matches property
    setIsMobile(mql.matches);

    return () => {
      if (mql.removeListener) {
        mql.removeListener(onChange);
      } else {
        mql.removeEventListener('change', onChange);
      }
    };
  }, []);

  return !!isMobile;
}

export default useIsMobile;
